var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHafeez(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1738 29.1504C38.1738 29.1504 38.1738 29.1602 38.1836 29.1602C39.082 31.0547 39.5898 33.1738 39.5898 35.4102C39.5801 43.4668 33.0566 50 25 50C16.9434 50 10.4199 43.4668 10.4199 35.4199C10.4199 33.1836 10.9277 31.0645 11.8262 29.1699C11.9922 28.8184 12.1777 28.4668 12.373 28.125C12.8027 27.3828 13.291 26.6895 13.8379 26.0449C16.5137 22.8613 20.5273 20.8398 25.0098 20.8398C28.291 20.8398 31.3184 21.9238 33.7598 23.7598C34.6484 24.4336 35.459 25.1953 36.1816 26.0547C36.7285 26.6992 37.2168 27.4023 37.6465 28.1348C37.8418 28.4668 38.0176 28.8184 38.1836 29.1602L38.1738 29.1504ZM40.752 27.3145C37.8125 21.6113 31.8652 17.7051 25 17.7051C18.1348 17.7051 12.1875 21.6113 9.24805 27.3145L0 19.7949L25 0L50 19.7949L40.752 27.3242V27.3145Z",
    fill: "#075985"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHafeez);
export default __webpack_public_path__ + "static/media/Hafeez.a7f15615835ebf3567e5e2ec3ad1b3e7.svg";
export { ForwardRef as ReactComponent };